import React, {useState, useEffect} from 'react';
// import { Jumbotron } from 'react-bootstrap';
import logo from '../img/medsolutions.jpg';
import {  Modal, Form,Button } from 'react-bootstrap';
//import consultasHoje from './consultasHoje';
import DashAvisos from './dashboads/dashAvisos';
import DashConsultas from './dashboads/dashConsultas';
import DashCPacientes from './dashboads/dashPacientes';
import DashProcedimentos from './dashboads/DashProcedimentos';
import DashStatus from './dashboads/DashStatus';
import DashPlanos from './dashboads/DashPlanos';
import './dashboard.css'
import api from './conexao.js';
import logOut from './logOut';



function DashBoard() {
const [mostraModalAviso, setmostraModalAviso] = useState(true);
const [checkAviso, setCheckAviso] = useState(true); //disable então true

let tokin = localStorage.getItem('token')  //LE O TOKEN QUE FOI GRAVADO NO LOGIN
var payload = tokin.split('.')[1];
var decodedPayload = JSON.parse(window.atob(payload));
var data_consentimento = new Date();
const [MSG, setMSG] = useState();
const [modalMSG, setModalMSG] = useState(false);
const [avisos, setAvisos] = useState([])
const [indiceAviso, setIndiceAviso] = useState(0);

useEffect(() =>  {
    api.get('/aviso')
        .then( (result) => {
            // console.log(result.data)
            if (result.data[0]) {
                setAvisos(result.data)
                // console.log(result.data)
            }
    })
},[])

function check(){

    if ( checkAviso ) {setCheckAviso(false)} 
        else {setCheckAviso(true)}  
}

function transformaData(d){  
    if (d != null) {                   // converte data = new Date() para DD/MM/YYYY 
            var date = new Date(d)                      // converte a data ISO DateTimeStamp(como vem do banco) para DD/MM/YYYY

            return(date.getFullYear()+'/' + (date.getMonth()+1) + '/'+date.getDate() + ' ' + date.getHours() + ':' + date.getMinutes()+':' + date.getSeconds())   ;
    }
}

async function gravaAviso() {
    
    await api.post('/aviso', {
        TIPO_DOCUMENTO: avisos[indiceAviso].TIPO_DOCUMENTO,
        TITULO: avisos[indiceAviso].TITULO,
        TEXTO: avisos[indiceAviso].TEXTO,
        VERSAO: avisos[indiceAviso].VERSAO,
        DATA_PUBLICACAO: transformaData(avisos[indiceAviso].DATA_PUBLICACAO),
        COD_USUARIO: null,
        NOME_USUARIO: decodedPayload.param2,
        DATA_CONSENTIMENTO: transformaData(data_consentimento)
    }).then( () => {setmostraModalAviso(false); // ´POSTA QUE CONSENTIU E CHAMA PROX.
        if (indiceAviso < avisos.length) {
            setIndiceAviso(indiceAviso+1); // soma para o prox. indice
            setmostraModalAviso(true);
            setCheckAviso(true) // desativa o botão de check

        api.put('/avisotenant',{
            COD_AVISO: avisos[indiceAviso].COD_AVISO
        }).then()
        .catch((error) => {
            setMSG(logOut(error))
            setModalMSG(true)
        })

        } else {setmostraModalAviso(false)} // NAO CHAMA PROXIMO
})
.catch((error) => {
        setMSG(logOut(error))
        setModalMSG(true)
    })
}

    return ( 
        <div>
              <center>
                <br />
                <br />
                    <img src={logo} width="380" height="100" alt=""/>
                    <br />
                <br />
            </center> 
<br />
<div className="dashboard"> 
    <div className="grid-container"> 
        <div className="grid-item"><DashConsultas /></div> 
        <div className="grid-item"><DashAvisos /></div> 
        <div className="grid-item"><DashStatus /></div>
        {/* <div className="grid-item"><DashCPacientes /></div>  */}
        <div className="grid-item"><DashProcedimentos /></div>
        <div className="grid-item"><DashPlanos /></div>
        
    </div> 
</div>

{ avisos.length > indiceAviso &&
    <Modal show={mostraModalAviso}>
    
        <Modal.Header> 
            <h4>{avisos[indiceAviso].TIPO_DOCUMENTO}</h4>
        </Modal.Header> 
        <Modal.Body>
        <h6>{avisos[indiceAviso].TITULO}</h6>    
        <p> {avisos[indiceAviso].TEXTO}</p>
            <p></p> 
            <p>Click em 'Lí e Entendi' o Aviso:</p>
            <p></p>
            <Form.Check 
                type="switch"
                //id="dia avulso"
                label="Lí e Entendi"
                value="1"
                checked={!checkAviso}
                onChange={() => check()}
            />
        </Modal.Body>
        <Modal.Footer>
            <Button type="button" 
                disabled={checkAviso}
                onClick={() => gravaAviso()}
            >Gravar e Fechar</Button>
        </Modal.Footer>
    </Modal> 
}
              <Modal show={modalMSG}>
                <Modal.Header> 
                    <h3>{MSG}</h3>
                </Modal.Header> 
                <Modal.Footer>
                    <Button variant="info" onClick={() => setModalMSG(false)}>Ok</Button>
                </Modal.Footer>
            </Modal> 

        </div>

    )
}

export default DashBoard;